import React from 'react';
import {
    HeroTeaserLoadingPlaceholder,
    HeroImage as HeroImageShared,
    useAnalyticsPageViewTracker,
    useOidcAuthentication,
} from '@cp-shared-19/frontend-ui';
import { withLoadingAndNoConnectionHandler } from 'components/integration-wrapper';
import { useLogin } from 'auth/useLogin';
import { prependBrandInProduction } from '../../utils';
import { HeroTeaserDto } from 'cpes-common';
import { useTranslation } from 'react-i18next';
import { useAemResponsiveImageSource, AemImageSizes, getTeaserImageBreakpoints } from 'aem-cms';
import { currentBrand } from 'config';

const imageBreakpoints = getTeaserImageBreakpoints(currentBrand);

const HeroImageWithWrappers = withLoadingAndNoConnectionHandler(HeroImageShared);

export const LandingPageHeroTeaser: React.FC = () => {
    const { t } = useTranslation('landing-page-hero-teaser');
    const imageUrl = useAemResponsiveImageSource(
        t('image.sizes', { returnObjects: true, defaultValue: {} }) as AemImageSizes,
        imageBreakpoints,
    );
    const { isAuthenticated } = useOidcAuthentication();
    const onLoginCallback = useLogin();
    const landingPageHeroTeaser: HeroTeaserDto = {
        title: t('title'),
        imageUrl: imageUrl ?? '',
        text: t('text'),
        buttonText: t('buttonText'),
        isInverted: !!t('isInverted'),
    };

    useAnalyticsPageViewTracker('landingPage', !!landingPageHeroTeaser, isAuthenticated);

    return (
        <HeroImageWithWrappers
            isLoading={false}
            hasError={!landingPageHeroTeaser}
            title={landingPageHeroTeaser?.title || ''}
            imageUrl={prependBrandInProduction(landingPageHeroTeaser?.imageUrl) || ''}
            subTitle={landingPageHeroTeaser?.subTitle}
            text={landingPageHeroTeaser?.text}
            buttonText={landingPageHeroTeaser?.buttonText}
            clickHandler={onLoginCallback}
            inverted={!!landingPageHeroTeaser?.isInverted}
            loadingPlaceholder={<HeroTeaserLoadingPlaceholder withTitle withSubTitle withButton />}
        />
    );
};
